import { useMemo } from "react";
import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import { useContext } from "react";
import ToastContext from "../../../services/Context/ToastContext"
import uuid from 'react-uuid';
import useReorderChoices from "./useReorderChoices";
import { txt } from "../../../services/translation";

export default function useCreateChoice(){

    const {quizId} = useParams()

    const {setToast} = useContext(ToastContext)

    const queryClient = useQueryClient()

    const queryKey = useMemo(() => ['design', quizId, 'choices'], [quizId]);

    const reorderChoices = useReorderChoices();

    return (question) => {

        const oldChoices = [...queryClient.getQueryData(queryKey)];

        let newRank = oldChoices.filter(s => s.question?.id === question.id).length + 1;

        let newChoice = {
            id: uuid(),
            title: '',
            rank: newRank,
            question: question,
            correct: true,
            explanation: '',
            edit: true
        }

        let newChoices = [...queryClient.getQueryData(queryKey)];
        newChoices.push(newChoice);
        newChoices = reorderChoices(newChoices);
        queryClient.setQueryData(queryKey, newChoices);

        newChoice = newChoices.find(s => s.id === newChoice.id)

        API.post(`/design/choices`, newChoice)
            .then(r => {
                console.log(r.data)
                API.put('/design/choices/reorder', newChoices)
            })
            .catch(() => {
                queryClient.setQueryData(queryKey, oldChoices)

                setToast({
                    severity: 'error',
                    message: txt('errorOccurred')
                })
            })
    }
}